import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, MapPin } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.complementodigital.shop/cart/40758159638657:1';
export function FinalCTA() {
  return <section className="py-12 md:py-24 px-4 text-center relative overflow-hidden" data-id="element-65">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[250px] md:h-[300px] bg-brand-500/10 blur-[100px] rounded-t-full pointer-events-none" data-id="element-66" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-67">
        <h2 className="text-4xl md:text-7xl font-bebas text-white mb-4 md:mb-8 leading-tight" data-id="element-68">
          NO SIGAS POSTERGANDO TU CAMBIO
        </h2>

        <div className="text-sm md:text-xl text-zinc-400 mb-6 md:mb-12 space-y-1.5 md:space-y-2" data-id="element-69">
          <p data-id="element-70">Cada día que pasa…</p>
          <p data-id="element-71">
            Tu energía baja. Tu motivación desaparece. Y tu confianza se
            deteriora más.
          </p>
          <p className="text-white font-bold mt-3 md:mt-6" data-id="element-72">
            Pero hoy puedes cambiar eso.
          </p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 p-5 md:p-8 rounded-2xl mb-6 md:mb-10" data-id="element-73">
          <div className="text-brand-500 font-bold uppercase tracking-widest text-[10px] md:text-sm mb-1 md:mb-2" data-id="element-74">
            EMPIEZA HOY MISMO
          </div>
          <h3 className="text-2xl md:text-4xl font-bebas text-white mb-2 md:mb-4" data-id="element-75">
            Entrena en Casa™
          </h3>
          <p className="text-zinc-400 text-xs md:text-base mb-5 md:mb-8" data-id="element-76">
            El sistema práctico para transformar tu cuerpo y tu mente desde
            casa.
          </p>

          <motion.a href={CHECKOUT_URL} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.96
        }} animate={{
          boxShadow: ['0 0 15px rgba(249,115,22,0.35)', '0 0 30px rgba(249,115,22,0.55)', '0 0 15px rgba(249,115,22,0.35)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="inline-block w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white font-bebas text-xl md:text-3xl px-6 md:px-10 py-4 md:py-5 rounded-xl transition-colors mx-auto text-center" data-id="element-77">
            🔥 QUIERO ACCEDER AHORA
          </motion.a>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1.5 text-[10px] md:text-sm text-zinc-500 font-medium" data-id="element-78">
          <div className="flex items-center gap-1" data-id="element-79">
            <Zap className="w-3 h-3 md:w-4 md:h-4" data-id="element-80" /> Acceso en minutos
          </div>
          <div className="flex items-center gap-1" data-id="element-81">
            <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-82" /> Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-83">
            <MapPin className="w-3 h-3 md:w-4 md:h-4" data-id="element-84" /> Toda Argentina
          </div>
        </div>
      </div>
    </section>;
}